/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'info': {
    width: 23,
    height: 23,
    viewBox: '0 0 23 23',
    data: '<g _fill="none" fill-rule="evenodd"><path pid="0" _stroke="#606060" stroke-width="1.658" d="M11.5 1C5.701 1 1 5.701 1 11.5S5.701 22 11.5 22 22 17.3 22 11.5 17.299 1 11.5 1z"/><text _fill="#606060" font-family="Sanchez Slab" font-size="16" font-weight="bold" transform="translate(1 1)"><tspan x="8" y="16">i</tspan></text></g>'
  }
})
